import React from 'react'
import Seo from '../components/seo/Seo'
import { useBreadcrumbs } from '../seo/useBreadcrumbs'

const Privacy: React.FC = () => {
  const crumbs = useBreadcrumbs([{ label: 'Privacy Policy', path: '/privacy' }], 'light')
  return (
    <div className="bg-sand min-h-screen py-24">
      <Seo
        title="Privacy Policy | Merritt & Shawn | Coastal Delaware Real Estate"
        description="How Merritt & Shawn | Coastal Delaware Real Estate — Shawn McDonnell & Merritt Cooch at Jack Lingo REALTOR® — collects, uses, and protects your information when you browse our site."
        path="/privacy"
        jsonLd={[crumbs.jsonLd]}
      />
      <div className="max-w-3xl mx-auto px-6">
        {crumbs.node}
        <p className="font-display text-[12px] uppercase tracking-[0.3em] font-bold text-accent-gold mb-4">
          Legal
        </p>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-primary-ink tracking-tight mb-10">
          Privacy Policy
        </h1>
        <div className="space-y-6 text-neutral-charcoal leading-relaxed font-sans">
          <p>
            Merritt & Shawn | Coastal Delaware Real Estate — Shawn McDonnell, Associate Broker, and Merritt Cooch, REALTOR®, of Jack
            Lingo REALTOR®, 1240 Kings Highway, Lewes, DE 19958 — respects your privacy. This policy explains
            what information we collect through this website and how it is used.
          </p>
          <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide">
            Information we collect
          </h2>
          <p>
            When you submit a contact or inquiry form, we collect the details you provide — typically your
            name, email address, phone number, and anything you include in your message. We use this
            information solely to respond to your inquiry and provide real estate services you request.
          </p>
          <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide">
            How we use it
          </h2>
          <p>
            We do not sell, rent, or share your personal information with third parties for their marketing
            purposes. Information is shared only as needed to provide the services you request (for example,
            coordinating with lenders, inspectors, or settlement attorneys at your direction).
          </p>
          <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide">
            Cookies and analytics
          </h2>
          <p>
            This site uses essential browser storage to remember privacy and accessibility preferences. Optional
            analytics load only after you accept them and help us understand general site usage. You may decline
            optional analytics without affecting access to the site.
          </p>
          <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide">
            Listing data
          </h2>
          <p>
            Property listing data on this site appears in part through the BRIGHT Internet Data Exchange
            program and is provided for consumers' personal, non-commercial use to identify prospective
            properties they may be interested in purchasing.
          </p>
          <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide">
            Contact
          </h2>
          <p>
            Questions about this policy? Contact us at{' '}
            <a href="mailto:shawn@jacklingo.com" className="text-accent-gold hover:underline">
              shawn@jacklingo.com
            </a>{' '}
            or call our office at{' '}
            <a href="tel:+13026452207" className="text-accent-gold hover:underline">
              302-645-2207
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  )
}

export default Privacy
